const ResultType = Object.freeze({
  success: "success",
  error: "error",
});

export default ResultType;